module.exports = __webpack_public_path__ + "static/img/1.ad5cd4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/1.png
// module id = BLhc
// module chunks = 1